'use client';
import React from 'react';
import PropTypes from 'prop-types';
import { interpolate } from '@format/interpolate';
import { useReporter } from '../../../reporter';
import { useOffer } from '../../../offer';
import { headerBannerClicked } from './events';
import { StyledDiscountBanner, OfferBannerText, OfferLink } from './styles';

export const DiscountBanner = ({
  sticky = false,
  promoMessage = 'Get {{offer}} off!',
  linkText,
  bgColor = 'background.dark',
  fontColor = 'text.lightest',
  typography = 'body',
  verticalPadding = 3,
  horizontalPadding = 0,
  showLink = true,
}) => {
  const link = {
    text: linkText || 'Try now!',
    target: '/onboarding/',
  };
  const { formattedAmount } = useOffer();
  const reporter = useReporter();
  const trackEvent = headerBannerClicked(promoMessage, link);
  return (
    <StyledDiscountBanner
      $sticky={sticky}
      $bgColor={bgColor}
      $fontColor={fontColor}
      $verticalPadding={verticalPadding}
      $horizontalPadding={horizontalPadding}
      $typography={typography}
    >
      {promoMessage && (
        <OfferBannerText>
          {interpolate(promoMessage, { offer: formattedAmount })}
        </OfferBannerText>
      )}
      {showLink && link && (
        <OfferLink href={link.target} onClick={() => reporter.tag(trackEvent)}>
          <OfferBannerText>{link.text}</OfferBannerText>
        </OfferLink>
      )}
    </StyledDiscountBanner>
  );
};

DiscountBanner.displayName = 'DiscountBanner';

DiscountBanner.propTypes = {
  sticky: PropTypes.bool,
  promoMessage: PropTypes.string,
  linkText: PropTypes.string,
  bgColor: PropTypes.string,
  fontColor: PropTypes.string,
  verticalPadding: PropTypes.number,
  horizontalPadding: PropTypes.number,
  showLink: PropTypes.bool,
};
